import { tableConstantsFactory } from './tableConstantsFactory';
const formConstants = tableConstantsFactory('FORM');

// add in extra constants here.
formConstants.BATCH_CHANGE = 'FORM_BATCH_CHANGE';
formConstants.FORMAT_CHANGE = 'FORM_FORMAT_CHANGE';
formConstants.SET_INITIAL_ACTIVE = 'FORM_SET_INITIAL_ACTIVE';
formConstants.RENDER = 'FORM_RENDER';
formConstants.RENDER_SUCCESS = 'FORM_RENDER_SUCCESS';
formConstants.RENDER_FAILURE = 'FORM_RENDER_FAILURE';
formConstants.UNDO_CHANGES_WITH_STATE = 'FORM_UNDO_CHANGES_WITH_STATE';
formConstants.ANNOTATION_CREATE_SUCCESS = 'ANNOTATION_CREATE_SUCCESS';
formConstants.RENDER_ANNOTATED_SUCCESS = 'FORM_RENDER_ANNOTATED_SUCCESS';
formConstants.RENDER_ANNOTATED_FAILURE = 'FORM_RENDER_ANNOTATED_FAILURE';
formConstants.CLEAR_DOWNLOAD_PATH = 'FORM_CLEAR_DOWNLOAD_PATH';
export default formConstants;